
import React from 'react';
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Homepage from './components/homepage';
import AboutPage from './company/about';
import Footer from './components/footer';
import Header from './components/header';


function App() {
  return (
    <Router>
<Header/>
      <Routes>
        <Route path='/' element={<Homepage/>}/>
        <Route path='/about 'element={<AboutPage/>} />
      </Routes>

  <Footer/>
    </Router>
   
  );
}

export default App;
